// Local i18n message definitions. IDs match what's in
// @techchange/components/src/_shared/i18n/translations/*.json, so the apps'
// existing translation bundles cover these strings automatically.

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	TC_COMPONENTS_USER_AVATAR_SPEAKER_BADGE_LABEL: {
		id: 'TC_COMPONENTS_USER_AVATAR_SPEAKER_BADGE_LABEL',
		defaultMessage: 'Speaker',
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_PREVIEW: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_PREVIEW',
		defaultMessage: 'Preview file',
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_SIZE: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_SIZE',
		defaultMessage: 'File size',
	},
	TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_REMOVE: {
		id: 'TC_COMPONENTS_FILE_DISPLAY_HOVER_TITLE_FILE_REMOVE',
		defaultMessage: 'Remove file',
	},
});
